<template>
  <div v-if="textList.length" class="box">
      <div class="top">
        <img class="tag" src="https://j5.dfcfw.com/sc/image/202308/20230809094616.png"/>
        <div @click="toMorePreferredProduct" class="top-right">
          <p class="more-text">更多优选产品</p>
          <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202308/20230802072333.png"/>
        </div>
      </div>
      <div class="info">
        <img class="title" src="https://j5.dfcfw.com/sc/image/202308/20230802072305.png"/>
        <p
          class="text"
          v-for="(item,index) in textList"
          :key="index"
          :style="item.style"
        >{{item.value}}</p>
      </div>
    </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  props: {
    fundCode: String,
    elementData: Object,
    mergeData: Object,
  },

  computed: {
    textList() {
      const info = this.mergeData?.optimalInfo || {};
      return info?.isOptimal && info.optimalReason ? this.handleText(info.optimalReason) : [];
    },
  },

  mounted() {
  },

  methods: {
    handleText(originText) {
      const list = originText.split('');
      const result = [];
      list.forEach((item) => {
        result.push({
          value: item,
          style: {
            fontFamily: 'PingFangSC-Regular',
          },
        });
      });
      return result;
    },

    toMorePreferredProduct() {
      if (multi.$system.webPlatform === 'wxmp') {
        const source = 'fund://mp.1234567.com.cn/weex/5cc0f0e04c6a48dea2270e6dbfaa35a3/pages/topicWebview/indexNew';
        const convertUrl = tool.getJumpUrl(source);
        if (source === convertUrl) {
          this.$goFundApp();
          return;
        }
        wx.miniProgram.navigateTo({
          url: convertUrl,
        });
        return;
      }
      multi.$router.push({
        url: 'fund://mp.1234567.com.cn/weex/5cc0f0e04c6a48dea2270e6dbfaa35a3/pages/topicWebview/indexNew',
        type: 2,
      });
    },
  },
};
</script>

<style scoped>
.box {
  margin-top: 16px;
  padding: 24px;
  background-image: url('https://j5.dfcfw.com/sc/image/202308/20230810013740.png');
  border-radius: 12px;
}

.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.tag {
  width: 158px;
  height: 44px;
}

.top-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.more-text {
  font-size: 28px;
  color: #592F1F;
}

.right-arrow {
  width: 12px;
  height: 20px;
  margin-left: 8px;
}

.title {
  width: 112px;
  height: 28px;
  margin-right: 12px;
}
.text {
  font-size: 28px;
  color: #592F1F;
  line-height: 40px;
}

.info {
  display: flex;
  margin-top: 25px;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
</style>
